import type { SVGProps } from "react";
import * as React from "react";
import { type iconSize, iconSizeVariants } from "@remi/types/icons";

type SvgIconProps = SVGProps<SVGSVGElement> & {
  size?: iconSize;
};
const Search = ({ size = "sm", ...props }: SvgIconProps) => {
  props.width = iconSizeVariants[size];
  props.height = iconSizeVariants[size];
  return (
    <svg {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.73141 10.7159C8.92631 11.3151 7.92839 11.6697 6.84765 11.6697C4.17744 11.6697 2.01282 9.50503 2.01282 6.83483C2.01282 4.16463 4.17744 2 6.84765 2C9.51785 2 11.6825 4.16463 11.6825 6.83483C11.6825 7.94792 11.3063 8.97315 10.6742 9.79035L13.7909 12.8696C14.0504 13.126 14.053 13.5442 13.7966 13.8037C13.5402 14.0632 13.122 14.0657 12.8625 13.8094L9.73141 10.7159ZM10.3615 6.83483C10.3615 8.77546 8.78828 10.3487 6.84765 10.3487C4.90702 10.3487 3.33382 8.77546 3.33382 6.83483C3.33382 4.8942 4.90702 3.32101 6.84765 3.32101C8.78828 3.32101 10.3615 4.8942 10.3615 6.83483Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default Search;
